export var DesktopPlatform;
(function (DesktopPlatform) {
    DesktopPlatform["Windows"] = "windows";
    DesktopPlatform["MacOS"] = "macos";
    DesktopPlatform["MacOSARM"] = "macos-arm";
})(DesktopPlatform || (DesktopPlatform = {}));
